/* eslint-disable no-underscore-dangle */
const useInitialProps = (staticContext) => {
  if (staticContext && staticContext.data) {
    return staticContext.data
  }
  if (window.__INITIAL_PROPS__) {
    return window.__INITIAL_PROPS__
  }
  return {}
}

export default useInitialProps
